<template>
  <ion-fab v-if="whappyClientConfig.name == 'Yoube'" vertical="bottom" horizontal="end">
    <ion-fab-button @click="$router.push('/shopping-cart')" class="ion-margin-end ion-margin-bottom">
      <ion-icon :icon="cart"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <ion-fab v-if="whappyClientConfig.name == 'Trivellato' ||
    whappyClientConfig.name == 'Automotive SpA'
    " vertical="bottom" horizontal="end">
    <ion-fab-button v-if="showComponent.ACCION_RAPIDA" @click="openModalNewKpiChat" class="ion-margin-end ion-margin-bottom" color="light">
      <ion-icon :icon="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <campaign-list-layout :showInfoPopHover="true" :showProfilePic="this.whappyClientConfig.showAvatarCampaigns"
    :infoPopHover="whappyClientConfig.name == 'Yoube'
      ? INFOPOPOVER_MAP[whappyClientConfig.name]
      : INFOPOPOVER_MAP['default']
      " smallTitle="true" bigTitle="Campagne" :showBack="false" titleStyle="vertical" :noPadding="true">
    <div class="page">
      <div class="w-full h-full flex flex-column"> 
        <div v-if="showComponent.CAMPAIGN" :style="{
          'max-height':
            whappyClientConfig.name == 'Demo' ||
              whappyClientConfig.name == 'Automotive SpA'
              ? '80vh'
              : '100vh',
          'overflow-y': 'scroll',
          'margin-top': '70px'
        }">   <div class="mt-4 w-full flex justify-content-between align-items-center section-title">
          <h4 class="font-bold" >Le tue campagne</h4>
          <div class="horizontal-bar"></div>
        </div>
          <template v-if="loadingCampaigns">
            <p class="greeting-tag">Caricamento in corso...</p>
          </template>

          <template v-else-if="displayList !== null && displayList.length === 0">
            <p class="greeting-tag">
              {{ $t("campaigns.no_campaigns") }}
            </p>
          </template>
          <transition-group name="block-slide-in">
            <template v-for="(listItem, i) in displayList" :key="i">
              <trCard :style="{ '--i': i, 'max-height': '150px', height: '150px' }"
              
                :img="listItem.url_mission_cover && listItem.show_cover_in_menu" v-if="showList1 && showList2"
                @click="$router.push(getCampaignDefaultUrl(listItem))" cardType="secondary" sideWidth="lg" class="mb-4 card-campaign"
                :percCompletamento="true">
                <template #perc-completamento>
                  {{ Number(listItem.percentualeCompletamento).toFixed(0) }}%
                </template>
                <template #main>
                  <div class="w-full flex flex-column py-2">
                    <div class="flex flex-column campaign-name-and-details my-2">
                      <span class="text-14 font-bold campagne-card-text">
                        {{ listItem.title }}
                      </span>
                      <span class="text-14 campagne-card-text">
                        {{ trimString(listItem.description, 43) }}
                      </span>
                    </div>
                    <div class="w-full h-full progressbar py-2 my-2">
                      <div class="campaign-datetime text-color-gray mb-2">
                        <span class="text-10 campagne-card-text">{{
                          new Date(listItem.data_inizio).toLocaleDateString(
                            "it",
                            {
                              year: "2-digit",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          )
                        }}</span>
                        -
                        <span class="text-10 campagne-card-text">{{
                          new Date(listItem.data_fine).toLocaleDateString(
                            "it",
                            {
                              year: "2-digit",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          )
                        }}</span>
                      </div>
                      <dark-common-progress-bar :value="(listItem.totalNumberOfDays -
                            listItem.remainingNumberOfDays) /
                          listItem.totalNumberOfDays
                          "></dark-common-progress-bar>
                      <span v-if="listItem.remainingNumberOfDays > 0" class="text-10">{{ listItem.remainingDaysString
                      }}</span>
                      <span class="text-10 campagne-card-text" v-else>La campagna è terminata</span>
                    </div>
                  </div>
                </template>
                <template #right-side>
                  <div class="campaign-img">
                    <img v-if="listItem.url_mission_cover &&
                      listItem.show_cover_in_menu
                      " :src="listItem.url_mission_cover" @error="handleImgError" />
                  </div>
                </template>
              </trCard>
            </template>
          </transition-group>
        </div>
        

  <div v-if="showComponent.PENDING" :style="{ 'margin-top': showComponent.CAMPAIGN ? '1rem' : '7rem' }">
        <div class="w-full flex justify-content-between align-items-center section-title">
          <h4 class="font-bold" style="font-size: large">Attitiva Pending({{ items.length }})
          </h4>
          <div class="horizontal-bar"></div>

        </div>

          <div  class="horizontal-scroll">
  <div v-for="(item) in items" :key="item.name" 
       class="item-container card-campaign">
    <div class="item-content campagne-card-text">
      <span>{{ item.name }}</span>
    </div>
    <button @click="openDetails(item)"
            class="details-button campagne-card-text">
      Dettagli
    </button>
  </div>
</div>
</div>
<div v-if="showComponent.NEWS">
        <div v-if="whappyClientConfig.name == 'Demo' ||
          whappyClientConfig.name == 'Automotive SpA'"
          class="w-full flex justify-content-between align-items-center section-title">
          <h4 class="font-bold">News feed</h4>
          <div class="horizontal-bar"></div>
        </div>
        <div v-if="whappyClientConfig.name == 'Demo' ||
          whappyClientConfig.name == 'Automotive SpA'" style="max-height: 30vh; overflow-y: scroll">
          <div class="horizontal-scroll">
            <div class="horizontal-box-container">
              <template v-for="(item, index) in posts" :key="index">
                <NewsCard 
      :item="item" @update-reactions="updateReactions($event, item)" />
              </template>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </campaign-list-layout>
</template>

<script>
import ApiService from "../common/service.api";
import trCard from "@/components/Nuovi/trCard.vue";
import NewsCard from "@/components/Nuovi/NewsCard.vue";

import {
  IonCard,
  IonCardContent,
  IonIcon,
  IonItem,
  IonRow,
  IonCol,
  modalController,
  IonFabButton,
  IonFab,
  IonLabel,
  IonList,
  IonPage
} from "@ionic/vue";
import CampaignService from "../common/mixins/Campaign";
import UserService from "../common/mixins/User";
import { IonProgressBar } from "@ionic/vue";

import {
  stopwatchOutline,
  eyeOutline,
  cart,
  add,
  cartOutline,
  list,
} from "ionicons/icons";
import CampaignListLayout from "../components/CampaignListLayout.vue";
import DarkCommonProgressBar from "../components/DarkCommonProgressBar";
import ModalNewOrdine from "./Modals/ModalNewOrdine.vue";
import { useGeneralStore } from "../stores/useGeneralStore";

const generalStore = useGeneralStore();

export default {
  name: "Campaigns",
  components: {
    IonLabel,
    CampaignListLayout,
    ModalNewOrdine,
    IonItem,
    IonCard,
    IonCardContent,
    IonIcon,
    IonProgressBar,
    DarkCommonProgressBar,
    IonRow,
    IonCol,
    trCard,
    NewsCard,
    IonFabButton,
    IonFab,
    IonList,
    IonPage
  },
  mixins: [CampaignService, UserService],
  created() {
    // this.getGenUsers();
    this.loadingCampaigns = true;
    var data = this.getCampaigns({
      filterForHome: true,
      forceRefresh: true,
    })
      .then((data) => {
        this.displayList.splice(0);
        if (this.settings.skip_menu_campagne && data.length) {
          this.$router.push(this.getCampaignDefaultUrl(data[0]));
        }
        data.forEach((element) => {
         /*  element.view_supervisor = this.isSupervisedCampaign(element); */
          this.displayList.push(element);
          setTimeout(() => {
            this.$nextTick(() => {
              this.showList1 = true;
            });
          }, 1);
        });
        /*  this.displayList = data; */
      })
      .finally(() => {
        this.loadingCampaigns = false;
      });
  },
  async mounted() {
   
    this.getPosts(); 
 
    setTimeout(() => {
      this.$nextTick(() => {
        this.showList2 = true;
      });
    }, 1);
    await this.getThemeConfig(); 
    this.applyTheme();
  },
  data() {
    return {
      posts: [],
      themeConfig: {},
      showComponent: {
      CAMPAIGN: true,
      PENDING: true,
      NEWS: true,
      ACCION_RAPIDA: true,
      ACCION_RAPIDA_ICONA: "add",
      ACCION_RAPIDA_URL: "/quick-action"
    },
      items: [
        { name: 'Completamento del percorso di OnBoarding' },
        { name: 'Raggiungimento del 40% nel Badge "Top Vendite"' },
        { name: 'Meet con il tuo Supervisore' },
        { name: 'Inizio della campagna "Agosto 2024"' },
      ],
   
      loadingCampaigns: false,
      cart,
      add,
      cartOutline,
      stopwatchOutline,
      userAvatar: null,
      displayList: [],
      isSupervised: false,
      eyeOutline,
      showList1: false,
      showList2: false,
      INFOPOPOVER_MAP: {
        Yoube:
          "In questa sezione trovi le campagne extra promozionali a te dedicate. Piccole azioni ti faranno accumulare riconoscimenti e crediti. Potrai tenere monitorate le tue statistiche e cosa ti manca per ottenere riconoscimenti e premi.",
        default:
          "In questa sezione trovi le campagne extra promozionali a te dedicate. Piccole azioni ti faranno accumulare riconoscimenti e crediti. Potrai tenere monitorate le tue statistiche e cosa ti manca per ottenere riconoscimenti e premi.",
      },
      options: [],
    };
  },

  methods: {
    async getPosts() {
      try {
        const response = await ApiService.get("SocialPost/GetPosts");
        this.posts = response.data; 
      } catch (error) {
        console.error("Error al obtener los posts:", error);
      }
    },
    async getThemeConfig() {
  const companyId = localStorage.getItem("companyId");
  if (!companyId) return;

  try {
    let res = await ApiService.get(`/AppSetting/${companyId}`);
    
    this.themeConfig = res.data;
    
    this.showComponent = {
      CAMPAIGN: this.themeConfig.HEnableCampaign ?? true,
      PENDING: this.themeConfig.HEnablePending ?? true,
      NEWS: this.themeConfig.HEnableSocial ?? true,
      ACCION_RAPIDA: this.themeConfig.HEnableRAction ?? false,
      ACCION_RAPIDA_ICONA: this.themeConfig.RActionIcon || "add",
      ACCION_RAPIDA_URL: this.themeConfig.RActionPath || "/quick-action",
    };
  } catch (error) {
    console.error("Error", error);
  }
},

    applyTheme() {
      const root = document.documentElement;
      Object.keys(this.themeConfig).forEach((key) => {
          const cssVariableName = `--${key}`;
          root.style.setProperty(cssVariableName, this.themeConfig[key]);
    
      });
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    getGenUsers() {
      generalStore.getUsers();
    },
    trimString(str, maxLength) {
      if (str.length > maxLength) {
        return str.substring(0, maxLength - 3) + "...";
      }
      return str;
    },
    updateReactions(event, item) {
      console.log("UPDATE REACTIONS", { event, item });
      item.reactions = event;
    },
    handleImgError() {
      return "https://placehold.co/300x300?text=MartechRevolution";
    },
    async openModalNewKpiChat() {
      const modal = await modalController.create({
        component: ModalNewOrdine,
        cssClass: "common-modal",
      });

      modal.onDidDismiss().then(async () => {
        await ApiService.get(`SalesChat/GetOrders`).then((res) => {
          this.items = [];
          res.data.forEach((element) => {
            this.items.push(element);
          });
        });
      });
      return modal.present();
    },
  },
};
</script>

<style lang="scss" scoped>
ion-card {
  --background: var(--ion-color-primary);

  &.closed {
    --background: var(--ion-color-primary-shade);
  }

  color: var(--text-color-light);

  ion-icon {
    font-size: 150%;
    margin: 0 5px -3px 0;
  }
}
.card-campaign {
  background: var(--HCardBg) !important;
}
.campagne-card-text{
  color: var(--HCardText) !important;
}
.status {
  width: 70%;
  float: left;
  font-size: 70%;
}

.percentage {
  width: 30%;
  float: left;
  text-align: right;
  font-weight: bold;
}

.details {
  width: 100%;
  clear: both;

  h3 {
    font-size: 110%;
    color: var(--text-color-light);
    font-weight: bold;
    margin-bottom: 0px;
  }

  .period {
    font-size: 70%;
  }
}

.page {
  background: white;
  padding: 1rem;
  min-height: calc(100vh - 220px);
}

.campaign-img {
  height: 100%;
  max-height: 222px !important;

  img {
    height: 100%;
    object-fit: cover;
  }
}

.section-title {
  color: var(--ion-color-primary);
}

.horizontal-bar {
  max-width: 50%;
  width: 100%;
  height: 3px;
  background-color: var(--ion-color-primary);

  margin-top: 10px;
}

.horizontal-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  padding: 10px;
}

.horizontal-box-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
}

.news-card {
  scroll-snap-align: start;
}
//attiva pending
.item-container {
  position: relative; 
  min-width:140px;
  padding: 12px 16px;
  background: var(--ion-color-secondary);
  color: var(--ion-color-primary);
  border-radius: var(--ion-border-radius);
  margin-bottom: 0;
  margin-right: 1rem;
  min-height: 100px;
}

.item-content {
  min-height: 40px;
}

.details-button {
  position: absolute;
  bottom: 8px;
  right: 8px; 
  background: transparent;
  border: none;
  color: var(--ion-color-primary);
  font-size: 0.8rem;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.3s;
  margin-top: 1rem;
}

.details-button:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>
